(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('TagService', TagService);

    TagService.$inject = ['TagFactory'];

    function TagService(TagFactory) {

        var service = {
            createTag: createTag,
            getTagsByStore : getTagsByStore,
            findTags: findTags,
            deleteTag: deleteTag
        };

        return service;

        function createTag(Tag) {
            return TagFactory.createTag(Tag).$promise;
        }

        function getTagsByStore(pageable, search, onSuccess, onError){
            return TagFactory.getTagsByStore(
                {
                    page: pageable.page,
                    size: pageable.size,
                    search: search,
                }, onSuccess, onError);
        }

        function findTags(text) {
            return TagFactory.findTagsByStore({ text: text }).$promise;
        }

        function deleteTag(tagId){
            return TagFactory.deleteTag({tagId: tagId}).$promise;
        }
    }

})();
